import { DripContentTemplate } from "@/types/email";

/**
 * Password Reset Email Template
 */
export const getPasswordResetEmailTemplate = (name: string, resetLink: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Reset Your AISEOBlogGenerator Password</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
        .expiry-notice { font-size: 13px; color: #666; margin-top: 15px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Reset Your Password</h1>
      </div>
      <div class="content">
        <p>Hi ${name},</p>
        <p>You requested to reset your password for <span class="accent">AISEOBlogGenerator</span>. No problem, we all forget things. Even the most powerful AI models have memory leaks sometimes.</p>
        
        <p>Click the button below to reset your password. This link expires in 1 hour for security reasons:</p>
        
        <div style="text-align: center;">
          <a href="${resetLink}" class="button">Reset My Password</a>
        </div>
        
        <p class="expiry-notice">If you didn't request a password reset, ignore this email and your password will remain unchanged.</p>
        
        <p>After resetting your password, you'll get back to creating content that doesn't sound like a corporate robot having an existential crisis.</p>
        
        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/wakeup.png" alt="Wake up" style="max-width: 150px; height: auto;" />
        </div>
        
        <p>We're keeping your seat warm,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Reset Your Password - AISEOBlogGenerator
    
    Hi ${name},
    
    You requested to reset your password for AISEOBlogGenerator. No problem, we all forget things. Even the most powerful AI models have memory leaks sometimes.
    
    Click the link below to reset your password. This link expires in 1 hour for security reasons:
    
    ${resetLink}
    
    If you didn't request a password reset, ignore this email and your password will remain unchanged.
    
    After resetting your password, you'll get back to creating content that doesn't sound like a corporate robot having an existential crisis.
    
    We're keeping your seat warm,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};

/**
 * Email Verification Template
 */
export const getEmailVerificationTemplate = (name: string, verificationLink: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Verify Your Email - AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
        .steps { background-color: #f8fafc; padding: 15px; border-radius: 5px; margin: 20px 0; }
        .steps h3 { margin-top: 0; color: #4A90E2; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Just One More Step!</h1>
      </div>
      <div class="content">
        <p>Hi ${name},</p>
        <p>Almost there! We need to verify your email address before you can start creating content that actually converts.</p>
        
        <div style="text-align: center;">
          <a href="${verificationLink}" class="button">Verify My Email</a>
        </div>
        
        <div class="steps">
          <h3>What happens next:</h3>
          <ol>
            <li>Click the button above to verify your email</li>
            <li>Get instant access to our AI-powered content generator</li>
            <li>Start creating content that doesn't make you want to delete your website</li>
          </ol>
        </div>
        
        <p>Your verification link will expire in 24 hours. If you don't verify within that time, you'll need to sign up again.</p>
        
        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/letaidothewriting.png" alt="Let AI do the writing" style="max-width: 150px; height: auto;" />
        </div>
        
        <p>Ready when you are,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
        <p>If you didn't create an account with us, you can ignore this email.</p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Verify Your Email - AISEOBlogGenerator
    
    Hi ${name},
    
    Almost there! We need to verify your email address before you can start creating content that actually converts.
    
    Please click the link below to verify your email:
    ${verificationLink}
    
    What happens next:
    1. Click the link above to verify your email
    2. Get instant access to our AI-powered content generator
    3. Start creating content that doesn't make you want to delete your website
    
    Your verification link will expire in 24 hours. If you don't verify within that time, you'll need to sign up again.
    
    Ready when you are,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
    
    If you didn't create an account with us, you can ignore this email.
  `;

  return {
    html,
    text
  };
};

/**
 * Trial Expiration Warning Email
 */
export const getTrialExpirationTemplate = (name: string, daysLeft: number, upgradeLink: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Your Free Trial is Ending Soon - AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        .countdown-box { background-color: #f8fafc; border-radius: 5px; padding: 15px; text-align: center; margin: 20px 0; }
        .countdown { font-size: 32px; font-weight: bold; color: #4A90E2; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
        .value-list { background-color: #f8fafc; padding: 15px; border-radius: 5px; margin: 20px 0; }
        .value-list li { margin-bottom: 8px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Your Free Trial is Ending Soon</h1>
      </div>
      <div class="content">
        <p>Hey ${name},</p>
        
        <div class="countdown-box">
          <p>Your free trial will end in:</p>
          <div class="countdown">${daysLeft} days</div>
        </div>
        
        <p>I wanted to give you a heads up that your trial is about to expire. </p>
        
        <p>Here's what you'll be missing if you don't upgrade:</p>
        
        <ul class="value-list">
          <li><strong>Increased post limit</strong> - Get 15+ posts per month instead of just 3</li>
          <li><strong>Premium AI models</strong> - Access to Claude 3.7 Sonnet and OpenAI's o1 models that produce significantly better content</li>
          <li><strong>Longer posts</strong> - Up to 4,000 words per post (vs. 2,000 with free plan)</li>
          <li><strong>Marketer mode</strong> - Unlock advanced content options designed specifically for conversions</li>
        </ul>
        
        <p>Here's the truth: Most people never upgrade, and that's fine.</p>
        
        <p>But a week from now, those same people will be staring at their screen, fiddling with ChatGPT prompts, trying to get it to spit out something that doesn't sound like it was written by a robot having an existential crisis.</p>

        <p>Meanwhile, Pro users are spending just 10 minutes to get a complete, SEO-optimized, human-sounding blog post that's ready to publish.</p>
        
        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/enterprise.png" alt="Enterprise Features" style="max-width: 200px; height: auto;" />
        </div>
        
        <div style="text-align: center;">
          <a href="${upgradeLink}" class="button">Keep Creating Great Content</a>
        </div>
        
        <p>You're getting results no one else is getting because you're doing what no one else is doing - creating content that doesn't suck.</p>
        
        <p>To your success,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Your Free Trial is Ending Soon - AISEOBlogGenerator
    
    Hey ${name},
    
    Your free trial will end in: ${daysLeft} days
    
    I wanted to give you a heads up that your trial is about to expire. 
    
    Here's what you'll be missing if you don't upgrade:
    
    - Increased post limit - Get 15+ posts per month instead of just 3
    - Premium AI models - Access to Claude 3.7 Sonnet and OpenAI's o1 models that produce significantly better content
    - Longer posts - Up to 4,000 words per post (vs. 2,000 with free plan)
    - Marketer mode - Unlock advanced content options designed specifically for conversions
    
    Here's the truth: Most people never upgrade, and that's fine.
    
    But a week from now, those same people will be staring at their screen, fiddling with ChatGPT prompts, trying to get it to spit out something that doesn't sound like it was written by a robot having an existential crisis.
    
    Meanwhile, Pro users are spending just 10 minutes to get a complete, SEO-optimized, human-sounding blog post that's ready to publish.
    
    Keep Creating Great Content: ${upgradeLink}
    
    You're getting results no one else is getting because you're doing what no one else is doing - creating content that doesn't suck.
    
    To your success,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};

/**
 * Subscription Expiring Soon Email
 */
export const getSubscriptionExpiringTemplate = (name: string, expirationDate: string, renewLink: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Your Subscription is Expiring Soon - AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        .notice-box { background-color: #f8fafc; border-radius: 5px; padding: 15px; border-left: 4px solid #4A90E2; margin: 20px 0; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Your Subscription is Expiring Soon</h1>
      </div>
      <div class="content">
        <p>Hey ${name},</p>
        
        <div class="notice-box">
          <p><strong>Quick heads up:</strong> Your AISEOBlogGenerator subscription will expire on <strong>${expirationDate}</strong>. We'd hate to see you lose access to your premium content tools.</p>
        </div>
        
        <p>Listen, we know your time is valuable. That's why you chose our tool in the first place - to stop wrestling with AI prompts and start generating content that actually converts.</p>

        <p>What happens if your subscription expires?</p>
        <ul>
          <li>Your account will downgrade to the free plan</li>
          <li>You'll be limited to only 3 posts per month (instead of 15+)</li>
          <li>Word count limits will drop from 4,000 to 2,000</li>
          <li>You'll lose access to premium AI models like Claude 3.7 Sonnet and OpenAI's o1</li>
        </ul>
        
        <p>The question isn't whether you need content - it's whether you want to go back to the slow, frustrating way of creating it.</p>

        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dontmakethatkindacontent.png" alt="Don't make that kind of content" style="max-width: 200px; height: auto;" />
        </div>
        
        <div style="text-align: center;">
          <a href="${renewLink}" class="button">Renew My Subscription</a>
        </div>
        
        <p>If you have any questions or need help with your renewal, hit reply to this email. We're here to help.</p>
        
        <p>Here's to more effortless, high-converting content,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Your Subscription is Expiring Soon - AISEOBlogGenerator
    
    Hey ${name},
    
    Quick heads up: Your AISEOBlogGenerator subscription will expire on ${expirationDate}. We'd hate to see you lose access to your premium content tools.
    
    Listen, we know your time is valuable. That's why you chose our tool in the first place - to stop wrestling with AI prompts and start generating content that actually converts.
    
    What happens if your subscription expires?
    - Your account will downgrade to the free plan
    - You'll be limited to only 3 posts per month (instead of 15+)
    - Word count limits will drop from 4,000 to 2,000
    - You'll lose access to premium AI models like Claude 3.7 Sonnet and OpenAI's o1
    
    The question isn't whether you need content - it's whether you want to go back to the slow, frustrating way of creating it.
    
    Renew My Subscription: ${renewLink}
    
    If you have any questions or need help with your renewal, hit reply to this email. We're here to help.
    
    Here's to more effortless, high-converting content,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};

/**
 * Content Generation Complete Email
 */
export const getContentGenerationCompleteTemplate = (name: string, contentTitle: string, contentLink: string, wordCount: number) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Your Content is Ready - AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        .content-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
        .stats { display: flex; justify-content: space-around; text-align: center; margin: 20px 0; }
        .stat-item { padding: 10px; }
        .stat-value { font-size: 24px; font-weight: bold; color: #4A90E2; }
        .stat-label { font-size: 14px; color: #666; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Your Content is Ready!</h1>
      </div>
      <div class="content">
        <p>Hey ${name},</p>
        
        <p>Good news! Your content generation job is complete and ready for your review.</p>
        
        <div class="content-box">
          <h2 style="margin-top:0;">${contentTitle}</h2>
          <div class="stats">
            <div class="stat-item">
              <div class="stat-value">${wordCount.toLocaleString()}</div>
              <div class="stat-label">Words</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">100%</div>
              <div class="stat-label">Complete</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">~${Math.round(wordCount/250)}</div>
              <div class="stat-label">Min Read</div>
            </div>
          </div>
        </div>
        
        <p>This isn't like the AI-generated garbage you've seen everywhere else. We've crafted this using premium AI models, custom strike lists to avoid clichés, and a writing style that actually sounds human.</p>
        
        <div style="text-align: center;">
          <a href="${contentLink}" class="button">View My Content</a>
        </div>
        
        <p>One click to generate, zero time wasted on endless prompt tweaking - that's the value you get with <span class="accent">AISEOBlogGenerator</span>.</p>
        
        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/noneofthis.png" alt="No more bad content" style="max-width: 200px; height: auto;" />
        </div>
        
        <p>Creating content that converts,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Your Content is Ready! - AISEOBlogGenerator
    
    Hey ${name},
    
    Good news! Your content generation job is complete and ready for your review.
    
    ${contentTitle}
    - Words: ${wordCount.toLocaleString()}
    - Complete: 100%
    - Estimated read time: ~${Math.round(wordCount/250)} minutes
    
    This isn't like the AI-generated garbage you've seen everywhere else. We've crafted this using premium AI models, custom strike lists to avoid clichés, and a writing style that actually sounds human.
    
    View My Content: ${contentLink}
    
    One click to generate, zero time wasted on endless prompt tweaking - that's the value you get with AISEOBlogGenerator.
    
    Creating content that converts,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};

/**
 * Blog Post Published Confirmation Email
 */
export const getBlogPostPublishedTemplate = (name: string, postTitle: string, postUrl: string) => {
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Your Blog Post is Live! - AISEOBlogGenerator</title>
      <style>
        body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
        .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
        .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
        .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
        .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
        .secondary-button { display: inline-block; background-color: #fff; color: #4A90E2; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; border: 1px solid #4A90E2; }
        .post-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
        h1 { color: #fff; }
        h2 { color: #D9974B; }
        .accent { color: #D9974B; font-weight: bold; }
        .logo-section { text-align: center; margin-bottom: 15px; }
        .logo { width: 100px; height: auto; }
        .social-share { display: flex; justify-content: center; gap: 10px; margin: 20px 0; }
        .social-button { display: inline-block; padding: 10px 15px; border-radius: 5px; color: white; text-decoration: none; font-weight: bold; }
        .twitter { background-color: #1DA1F2; }
        .facebook { background-color: #4267B2; }
        .linkedin { background-color: #0077B5; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="logo-section">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
        </div>
        <h1>Your Blog Post is Live!</h1>
      </div>
      <div class="content">
        <p>Hey ${name},</p>
        
        <p>Great news! Your blog post has been published and is now live on your site. </p>
        
        <div class="post-box">
          <h2 style="margin-top:0;">${postTitle}</h2>
          <p>Published just now and ready for the world to see.</p>
          <div style="text-align: center;">
            <a href="${postUrl}" class="button">View Published Post</a>
          </div>
        </div>
        
        <p>Want more eyes on your content? Share it with your network:</p>
        
        <div class="social-share">
          <a href="https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(`Check out my new post: ${postTitle}`)}" class="social-button twitter" target="_blank">Twitter</a>
          <a href="https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}" class="social-button facebook" target="_blank">Facebook</a>
          <a href="https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(postUrl)}&title=${encodeURIComponent(postTitle)}" class="social-button linkedin" target="_blank">LinkedIn</a>
        </div>
        
        <p>Remember: The most successful content marketers publish consistently. Ready to create your next piece?</p>
        
        <div style="text-align: center;">
          <a href="https://aiseobloggenerator.com/writer" class="secondary-button">Create Another Post</a>
        </div>
        
        <div style="text-align: center; margin: 30px 0;">
          <img src="https://emp3.b-cdn.net/seoblogtool/png/nobadphrases.png" alt="No bad phrases" style="max-width: 150px; height: auto;" />
        </div>
        
        <p>Keep publishing content that doesn't suck,<br>The AISEOBlogGenerator Team</p>
      </div>
      <div class="footer">
        <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
        <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
      </div>
    </body>
    </html>
  `;

  const text = `
    Your Blog Post is Live! - AISEOBlogGenerator
    
    Hey ${name},
    
    Great news! Your blog post has been published and is now live on your site.
    
    ${postTitle}
    Published just now and ready for the world to see.
    
    View Published Post: ${postUrl}
    
    Want more eyes on your content? Share it with your network:
    
    Twitter: https://twitter.com/intent/tweet?url=${encodeURIComponent(postUrl)}&text=${encodeURIComponent(`Check out my new post: ${postTitle}`)}
    Facebook: https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}
    LinkedIn: https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(postUrl)}&title=${encodeURIComponent(postTitle)}
    
    Remember: The most successful content marketers publish consistently. Ready to create your next piece?
    
    Create Another Post: https://aiseobloggenerator.com/writer
    
    Keep publishing content that doesn't suck,
    The AISEOBlogGenerator Team
    
    © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
    Privacy Policy: https://aiseobloggenerator.com/privacy
    Terms of Service: https://aiseobloggenerator.com/terms
  `;

  return {
    html,
    text
  };
};

/**
 * Onboarding Drip Email Templates
 * Contains a series of emails for the onboarding sequence
 */

// Define the drip content emails
export const onboardingDripTemplates: DripContentTemplate[] = [
  {
    id: "strike-list-intro",
    subject: "Stop Common AI Writing Mistakes With This Simple Feature",
    template: (name: string) => {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Strike List Feature - AISEOBlogGenerator</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
            .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
            .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
            .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
            .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
            .feature-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
            .example-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .example-table th, .example-table td { border: 1px solid #e2e8f0; padding: 10px; }
            .example-table th { background-color: #f8fafc; }
            .example-bad { color: #e53e3e; }
            .example-good { color: #38a169; }
            h1 { color: #fff; }
            h2 { color: #D9974B; }
            .accent { color: #D9974B; font-weight: bold; }
            .logo-section { text-align: center; margin-bottom: 15px; }
            .logo { width: 100px; height: auto; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-section">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/nobadphrases.png" alt="AISEOBlogGenerator Logo" class="logo" />
            </div>
            <h1>Stop AI Content From Sounding Like AI</h1>
          </div>
          <div class="content">
            <p>Hey ${name},</p>
            
            <p>You know what's the biggest giveaway that content was written by AI?</p>
            <p>It's those clichéd, overused phrases that make your readers mentally check out:</p>
            
            <ul>
              <li>"In today's fast-paced digital landscape..."</li>
              <li>"...unlock the full potential of..."</li>
              <li>"...leveraging the power of..."</li>
              <li>"It's worth noting that..."</li>
            </ul>
            
            <p>Every time someone reads these phrases, they immediately think "this was written by AI" and stop taking your content seriously.</p>
            
            <h2>Introducing: The Strike List Feature</h2>
            
            <p>Here's a powerful but little-known feature in AISEOBlogGenerator: you can ban specific words, phrases, and writing patterns that you never want to see in your content.</p>
            
            <div class="feature-box">
              <h3 style="margin-top:0;">How to Use the Strike List</h3>
              <ol>
                <li>Click the Ban icon (🚫) in the top navigation</li>
                <li>Add common AI phrases to each category</li>
                <li>Our AI will actively avoid using any of these terms</li>
              </ol>
              
              <p><strong>Pro tip:</strong> Add phrases like "in today's fast-paced digital landscape," "it goes without saying," and "unlock the potential" to instantly improve your content quality.</p>
            </div>
            
            <p>Here's the real value of this feature: while everyone else's AI content screams "I WAS WRITTEN BY A ROBOT," yours will sound natural and human.</p>
            
            <div style="text-align: center;">
              <a href="https://aiseobloggenerator.com/writer" class="button">Try the Strike List Feature Now</a>
            </div>

            <table class="example-table">
              <tr>
                <th>Without Strike List</th>
                <th>With Strike List</th>
              </tr>
              <tr>
                <td class="example-bad">
                  "In today's fast-paced digital landscape, businesses must leverage the power of content marketing to stay competitive."
                </td>
                <td class="example-good">
                  "Most businesses waste money on content marketing because they focus on quantity instead of quality."
                </td>
              </tr>
            </table>
            
            <div style="text-align: center; margin: 30px 0;">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/notwithnoncringe.png" alt="No more cringe" style="max-width: 150px; height: auto;" />
            </div>
            
            <p>To writing that doesn't make people cringe,<br>The AISEOBlogGenerator Team</p>
          </div>
          <div class="footer">
            <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
            <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
            <p>Want to stop receiving these emails? <a href="[unsubscribe_link]" style="color: #4A90E2;">Unsubscribe here</a>.</p>
          </div>
        </body>
        </html>
      `;

      const text = `
        Stop AI Content From Sounding Like AI - AISEOBlogGenerator
        
        Hey ${name},
        
        You know what's the biggest giveaway that content was written by AI?
        
        It's those clichéd, overused phrases that make your readers mentally check out:
        
        - "In today's fast-paced digital landscape..."
        - "...unlock the full potential of..."
        - "...leveraging the power of..."
        - "It's worth noting that..."
        
        Every time someone reads these phrases, they immediately think "this was written by AI" and stop taking your content seriously.
        
        Introducing: The Strike List Feature
        
        Here's a powerful but little-known feature in AISEOBlogGenerator: you can ban specific words, phrases, and writing patterns that you never want to see in your content.
        
        How to Use the Strike List:
        1. Click the Ban icon (🚫) in the top navigation
        2. Add common AI phrases to each category
        3. Our AI will actively avoid using any of these terms
        
        Pro tip: Add phrases like "in today's fast-paced digital landscape," "it goes without saying," and "unlock the potential" to instantly improve your content quality.
        
        Here's the real value of this feature: while everyone else's AI content screams "I WAS WRITTEN BY A ROBOT," yours will sound natural and human.
        
        Try the Strike List Feature Now: https://aiseobloggenerator.com/writer
        
        Examples:
        
        Without Strike List:
        "In today's fast-paced digital landscape, businesses must leverage the power of content marketing to stay competitive."
        
        With Strike List:
        "Most businesses waste money on content marketing because they focus on quantity instead of quality."
        
        To writing that doesn't make people cringe,
        The AISEOBlogGenerator Team
        
        © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
        Privacy Policy: https://aiseobloggenerator.com/privacy
        Terms of Service: https://aiseobloggenerator.com/terms
        
        Want to stop receiving these emails? Unsubscribe here: [unsubscribe_link]
      `;

      return {
        html,
        text
      };
    }
  },
  {
    id: "writing-styles-feature",
    subject: "Copy Famous Writers With This One-Click Feature",
    template: (name: string) => {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Writing Styles Feature - AISEOBlogGenerator</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
            .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
            .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
            .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
            .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
            .feature-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
            .styles-list { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin: 20px 0; }
            .style-item { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 10px; }
            .style-name { font-weight: bold; color: #4A90E2; }
            h1 { color: #fff; }
            h2 { color: #D9974B; }
            .accent { color: #D9974B; font-weight: bold; }
            .logo-section { text-align: center; margin-bottom: 15px; }
            .logo { width: 100px; height: auto; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-section">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithpencil.png" alt="AISEOBlogGenerator Logo" class="logo" />
            </div>
            <h1>Sound Like Your Favorite Writers</h1>
          </div>
          <div class="content">
            <p>Hey ${name},</p>
            
            <p>What if you could write like Morgan Housel, Naval Ravikant, or Simon Sinek... without spending 10+ years mastering their style?</p>
            
            <p>One of our most powerful features lets you do exactly that: <span class="accent">Writing Styles</span>.</p>
            
            <div class="feature-box">
              <h3 style="margin-top:0;">The Writing Styles Feature</h3>
              <p>Choose from our library of pre-built writing styles based on popular authors and thought leaders, or create your own custom style from scratch.</p>
              
              <p>How to use it:</p>
              <ol>
                <li>When creating a new post, find the "Writing Style" dropdown</li>
                <li>Select a style that matches your brand voice</li>
                <li>Generate your content - it will automatically adopt that writing style</li>
              </ol>
            </div>
            
            <p>Here's why this matters: The <em>way</em> your content is written is often more important than what it says. People connect with voices and stories, not just information.</p>
            
            <div class="styles-list">
              <div class="style-item">
                <div class="style-name">Simon Sinek</div>
                <p>Inspirational leadership with powerful storytelling</p>
              </div>
              <div class="style-item">
                <div class="style-name">Naval Ravikant</div>
                <p>Philosophical insights with clear, concise principles</p>
              </div>
              <div class="style-item">
                <div class="style-name">Morgan Housel</div>
                <p>Behavioral finance with unexpected connections</p>
              </div>
              <div class="style-item">
                <div class="style-name">Tim Urban</div>
                <p>Deep dives with humor and visual thinking</p>
              </div>
            </div>
            
            <p>Whether you want to sound authoritative, conversational, storytelling-focused, or educational, there's a style that fits your brand.</p>
            
            <div style="text-align: center;">
              <a href="https://aiseobloggenerator.com/writer" class="button">Try Different Writing Styles</a>
            </div>
            
            <p>The most successful content creators have a distinctive voice that stands out. With our writing styles feature, you can find yours without years of practice.</p>
            
            <div style="text-align: center; margin: 30px 0;">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/letaidothewriting.png" alt="Let AI Do The Writing" style="max-width: 150px; height: auto;" />
            </div>
            
            <p>To content with personality,<br>The AISEOBlogGenerator Team</p>
          </div>
          <div class="footer">
            <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
            <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
            <p>Want to stop receiving these emails? <a href="[unsubscribe_link]" style="color: #4A90E2;">Unsubscribe here</a>.</p>
          </div>
        </body>
        </html>
      `;

      const text = `
        Sound Like Your Favorite Writers - AISEOBlogGenerator
        
        Hey ${name},
        
        What if you could write like Morgan Housel, Naval Ravikant, or Simon Sinek... without spending 10+ years mastering their style?
        
        One of our most powerful features lets you do exactly that: Writing Styles.
        
        The Writing Styles Feature
        
        Choose from our library of pre-built writing styles based on popular authors and thought leaders, or create your own custom style from scratch.
        
        How to use it:
        1. When creating a new post, find the "Writing Style" dropdown
        2. Select a style that matches your brand voice
        3. Generate your content - it will automatically adopt that writing style
        
        Here's why this matters: The way your content is written is often more important than what it says. People connect with voices and stories, not just information.
        
        Available styles include:
        - Simon Sinek: Inspirational leadership with powerful storytelling
        - Naval Ravikant: Philosophical insights with clear, concise principles
        - Morgan Housel: Behavioral finance with unexpected connections
        - Tim Urban: Deep dives with humor and visual thinking
        
        Whether you want to sound authoritative, conversational, storytelling-focused, or educational, there's a style that fits your brand.
        
        Try Different Writing Styles: https://aiseobloggenerator.com/writer
        
        The most successful content creators have a distinctive voice that stands out. With our writing styles feature, you can find yours without years of practice.
        
        To content with personality,
        The AISEOBlogGenerator Team
        
        © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
        Privacy Policy: https://aiseobloggenerator.com/privacy
        Terms of Service: https://aiseobloggenerator.com/terms
        
        Want to stop receiving these emails? Unsubscribe here: [unsubscribe_link]
      `;

      return {
        html,
        text
      };
    }
  },
  {
    id: "marketer-mode-feature",
    subject: "The Secret Mode That Makes Your Content Convert",
    template: (name: string) => {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Marketer Mode Feature - AISEOBlogGenerator</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
            .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
            .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
            .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
            .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
            .feature-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
            .options-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin: 20px 0; }
            .option-item { background-color: #fff; border: 1px solid #e2e8f0; border-radius: 5px; padding: 10px; }
            .option-title { font-weight: bold; color: #D9974B; }
            .comparison-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .comparison-table th, .comparison-table td { border: 1px solid #e2e8f0; padding: 10px; text-align: left; }
            .comparison-table th { background-color: #f8fafc; }
            h1 { color: #fff; }
            h2 { color: #D9974B; }
            .accent { color: #D9974B; font-weight: bold; }
            .logo-section { text-align: center; margin-bottom: 15px; }
            .logo { width: 100px; height: auto; }
            .pro-label { display: inline-block; background-color: #D9974B; color: white; font-size: 12px; padding: 2px 6px; border-radius: 10px; margin-left: 5px; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-section">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/dogwithmoneytag.png" alt="AISEOBlogGenerator Logo" class="logo" />
            </div>
            <h1>Unlock Marketer Mode</h1>
          </div>
          <div class="content">
            <p>Hey ${name},</p>
            
            <p>Time for some ruthless truth-telling:</p>
            
            <p>The end goal of content isn't "to have content." It's to <span class="accent">drive specific business outcomes</span> - leads, sales, sign-ups, retention. Everything else is vanity.</p>
            
            <h2>Introducing: Marketer Mode <span class="pro-label">PRO</span></h2>
            
            <p>While most AI writing tools focus on creating generic content, our Marketer Mode is designed specifically to help you create content that <span class="accent">drives conversions</span>.</p>
            
            <div class="feature-box">
              <h3 style="margin-top:0;">How Marketer Mode Works:</h3>
              <p>When enabled, you'll get access to powerful marketing-specific options that shape your content for maximum impact:</p>
              
              <div class="options-grid">
                <div class="option-item">
                  <div class="option-title">Target Audience Selection</div>
                  <p>Content tailored specifically for B2B, B2C, technical audiences, executives, etc.</p>
                </div>
                <div class="option-item">
                  <div class="option-title">Content Goal Setting</div>
                  <p>Optimize for awareness, consideration, conversion, or retention goals.</p>
                </div>
                <div class="option-item">
                  <div class="option-title">Strategic CTA Controls</div>
                  <p>Add soft, medium, or hard CTAs that match your conversion funnel.</p>
                </div>
                <div class="option-item">
                  <div class="option-title">Competitor Angle</div>
                  <p>Position against competitors directly or indirectly, depending on your strategy.</p>
                </div>
              </div>
            </div>
            
            <p>Here's the stark difference:</p>
            
            <table class="comparison-table">
              <tr>
                <th>Standard Content</th>
                <th>Marketer Mode Content</th>
              </tr>
              <tr>
                <td>Informational but passive</td>
                <td>Strategically drives specific actions</td>
              </tr>
              <tr>
                <td>Generic audience targeting</td>
                <td>Precise messaging for specific buyer personas</td>
              </tr>
              <tr>
                <td>Unfocused call-to-actions</td>
                <td>CTAs aligned to buyer journey stage</td>
              </tr>
              <tr>
                <td>Misaligned with business goals</td>
                <td>Directly supports conversion objectives</td>
              </tr>
            </table>
            
            <p>Here's the bottom line: The difference between content that just sits there and content that actually produces results is <em>strategic intent</em>.</p>
            
            <div style="text-align: center;">
              <a href="https://aiseobloggenerator.com/upgrade" class="button">Upgrade to Pro & Unlock Marketer Mode</a>
            </div>
            
            <p>When you're ready to stop creating content for content's sake and start driving actual business results, Marketer Mode is waiting.</p>
            
            <div style="text-align: center; margin: 30px 0;">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/enterprise.png" alt="Enterprise Features" style="max-width: 150px; height: auto;" />
            </div>
            
            <p>To your revenue growth,<br>The AISEOBlogGenerator Team</p>
          </div>
          <div class="footer">
            <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
            <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
            <p>Want to stop receiving these emails? <a href="[unsubscribe_link]" style="color: #4A90E2;">Unsubscribe here</a>.</p>
          </div>
        </body>
        </html>
      `;

      const text = `
        Unlock Marketer Mode - AISEOBlogGenerator
        
        Hey ${name},
        
        Time for some ruthless truth-telling:
        
        The end goal of content isn't "to have content." It's to drive specific business outcomes - leads, sales, sign-ups, retention. Everything else is vanity.
        
        Introducing: Marketer Mode (PRO Feature)
        
        While most AI writing tools focus on creating generic content, our Marketer Mode is designed specifically to help you create content that drives conversions.
        
        How Marketer Mode Works:
        
        When enabled, you'll get access to powerful marketing-specific options that shape your content for maximum impact:
        
        - Target Audience Selection: Content tailored specifically for B2B, B2C, technical audiences, executives, etc.
        - Content Goal Setting: Optimize for awareness, consideration, conversion, or retention goals.
        - Strategic CTA Controls: Add soft, medium, or hard CTAs that match your conversion funnel.
        - Competitor Angle: Position against competitors directly or indirectly, depending on your strategy.
        
        Here's the stark difference:
        
        Standard Content:
        - Informational but passive
        - Generic audience targeting
        - Unfocused call-to-actions
        - Misaligned with business goals
        
        Marketer Mode Content:
        - Strategically drives specific actions
        - Precise messaging for specific buyer personas
        - CTAs aligned to buyer journey stage
        - Directly supports conversion objectives
        
        Here's the bottom line: The difference between content that just sits there and content that actually produces results is strategic intent.
        
        Upgrade to Pro & Unlock Marketer Mode: https://aiseobloggenerator.com/upgrade
        
        When you're ready to stop creating content for content's sake and start driving actual business results, Marketer Mode is waiting.
        
        To your revenue growth,
        The AISEOBlogGenerator Team
        
        © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
        Privacy Policy: https://aiseobloggenerator.com/privacy
        Terms of Service: https://aiseobloggenerator.com/terms
        
        Want to stop receiving these emails? Unsubscribe here: [unsubscribe_link]
      `;

      return {
        html,
        text
      };
    }
  },
  {
    id: "ai-models-feature",
    subject: "Why Your Content Generation Is Only As Good As Your AI Model",
    template: (name: string) => {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Premium AI Models - AISEOBlogGenerator</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
            .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
            .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
            .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
            .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
            .models-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .models-table th, .models-table td { border: 1px solid #e2e8f0; padding: 10px; }
            .models-table th { background-color: #f8fafc; }
            .free-tier { color: #718096; }
            .pro-tier { color: #4A90E2; font-weight: bold; }
            .enterprise-tier { color: #38a169; font-weight: bold; }
            .feature-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
            h1 { color: #fff; }
            h2 { color: #D9974B; }
            .accent { color: #D9974B; font-weight: bold; }
            .logo-section { text-align: center; margin-bottom: 15px; }
            .logo { width: 100px; height: auto; }
            .model-badges-container { display: flex; gap: 10px; flex-wrap: wrap; margin: 15px 0; }
            .model-badge { background-color: #f0f9ff; border: 1px solid #bfdbfe; border-radius: 30px; padding: 8px 12px; font-size: 14px; display: inline-flex; align-items: center; }
            .model-badge.advanced { background-color: #f0fdf4; border-color: #bbf7d0; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-section">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/enterprise.png" alt="AISEOBlogGenerator Logo" class="logo" />
            </div>
            <h1>The Engine Behind Great Content</h1>
          </div>
          <div class="content">
            <p>Hey ${name},</p>
            
            <p>Let me ask you something that most AI writing tools don't want to talk about:</p>
            
            <p><strong>Do you know which AI model is actually generating your content?</strong></p>
            
            <p>Most competitors use the cheapest, most basic models available (usually GPT-3.5 Turbo) and slap a nice interface on top. But here's the truth:</p>
            
            <p>The model matters. A lot.</p>
            
            <h2>Premium AI Models = Premium Results</h2>
            
            <p>With AISEOBlogGenerator, you have access to the most advanced AI models on the market, including:</p>
            
            <div class="model-badges-container">
              <div class="model-badge advanced">Claude 3.7 Sonnet</div>
              <div class="model-badge advanced">OpenAI o1 Pro</div>
              <div class="model-badge advanced">GPT-4o</div>
              <div class="model-badge">Claude 3.5 Sonnet</div>
              <div class="model-badge">GPT-4o Mini</div>
            </div>
            
            <p>These models cost us <span class="accent">10-20x more</span> to run than the basic models most tools use. But we absorb this cost because the quality difference is unmistakable.</p>
            
            <table class="models-table">
              <tr>
                <th>Model Type</th>
                <th>Content Quality</th>
                <th>Plan</th>
              </tr>
              <tr>
                <td>Basic LLMs (GPT-3.5 Turbo)</td>
                <td>Repetitive, obvious AI markers, limited reasoning</td>
                <td class="free-tier">Free Tier</td>
              </tr>
              <tr>
                <td>Premium LLMs (GPT-4o, Claude 3.5)</td>
                <td>Significantly more natural, better structured, higher quality</td>
                <td class="pro-tier">Pro Tier</td>
              </tr>
              <tr>
                <td>Elite LLMs (o1 Pro, Claude 3.7)</td>
                <td>Human-like quality, advanced reasoning, industry-leading output</td>
                <td class="enterprise-tier">Enterprise Tier</td>
              </tr>
            </table>
            
            <div class="feature-box">
              <h3 style="margin-top:0;">Pro Tip: How to Choose the Right Model</h3>
              <ul>
                <li><strong>GPT-4o:</strong> Great all-around model for most content needs</li>
                <li><strong>Claude 3.7 Sonnet:</strong> Exceptional for long-form, nuanced content</li>
                <li><strong>o1 Pro:</strong> Technical, complex topics with advanced reasoning</li>
              </ul>
            </div>
            
            <p>The scary reality? The difference between content that gets results and content that gets ignored often comes down to which model generated it.</p>
            
            <div style="text-align: center;">
              <a href="https://aiseobloggenerator.com/upgrade" class="button">Upgrade for Premium AI Models</a>
            </div>
            
            <p>You wouldn't run a race in flip-flops when everyone else has running shoes. Don't handicap your content with outdated AI models when your competitors are using the best.</p>
            
            <div style="text-align: center; margin: 30px 0;">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/broyourcontentsucks.png" alt="Bro your content sucks" style="max-width: 150px; height: auto;" />
            </div>
            
            <p>To the unfair advantage of better AI models,<br>The AISEOBlogGenerator Team</p>
          </div>
          <div class="footer">
            <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
            <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
            <p>Want to stop receiving these emails? <a href="[unsubscribe_link]" style="color: #4A90E2;">Unsubscribe here</a>.</p>
          </div>
        </body>
        </html>
      `;

      const text = `
        The Engine Behind Great Content - AISEOBlogGenerator
        
        Hey ${name},
        
        Let me ask you something that most AI writing tools don't want to talk about:
        
        Do you know which AI model is actually generating your content?
        
        Most competitors use the cheapest, most basic models available (usually GPT-3.5 Turbo) and slap a nice interface on top. But here's the truth:
        
        The model matters. A lot.
        
        Premium AI Models = Premium Results
        
        With AISEOBlogGenerator, you have access to the most advanced AI models on the market, including:
        - Claude 3.7 Sonnet
        - OpenAI o1 Pro
        - GPT-4o
        - Claude 3.5 Sonnet
        - GPT-4o Mini
        
        These models cost us 10-20x more to run than the basic models most tools use. But we absorb this cost because the quality difference is unmistakable.
        
        Model Comparison:
        
        Basic LLMs (GPT-3.5 Turbo)
        - Content Quality: Repetitive, obvious AI markers, limited reasoning
        - Plan: Free Tier
        
        Premium LLMs (GPT-4o, Claude 3.5)
        - Content Quality: Significantly more natural, better structured, higher quality
        - Plan: Pro Tier
        
        Elite LLMs (o1 Pro, Claude 3.7)
        - Content Quality: Human-like quality, advanced reasoning, industry-leading output
        - Plan: Enterprise Tier
        
        Pro Tip: How to Choose the Right Model
        - GPT-4o: Great all-around model for most content needs
        - Claude 3.7 Sonnet: Exceptional for long-form, nuanced content
        - o1 Pro: Technical, complex topics with advanced reasoning
        
        The scary reality? The difference between content that gets results and content that gets ignored often comes down to which model generated it.
        
        Upgrade for Premium AI Models: https://aiseobloggenerator.com/upgrade
        
        You wouldn't run a race in flip-flops when everyone else has running shoes. Don't handicap your content with outdated AI models when your competitors are using the best.
        
        To the unfair advantage of better AI models,
        The AISEOBlogGenerator Team
        
        © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
        Privacy Policy: https://aiseobloggenerator.com/privacy
        Terms of Service: https://aiseobloggenerator.com/terms
        
        Want to stop receiving these emails? Unsubscribe here: [unsubscribe_link]
      `;

      return {
        html,
        text
      };
    }
  },
  {
    id: "content-frameworks-intro",
    subject: "The Most Underrated Feature That Will 2X Your Content Results",
    template: (name: string) => {
      const html = `
        <!DOCTYPE html>
        <html>
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Content Frameworks Feature - AISEOBlogGenerator</title>
          <style>
            body { font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #FFF8E7; }
            .header { background-color: #4A90E2; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0; }
            .content { background-color: #fff; padding: 20px; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; }
            .footer { background-color: #f8fafc; padding: 20px; text-align: center; font-size: 12px; color: #64748b; border-radius: 0 0 5px 5px; border: 1px solid #e2e8f0; }
            .button { display: inline-block; background-color: #D9974B; color: white; text-decoration: none; padding: 10px 20px; border-radius: 5px; margin: 20px 0; font-weight: bold; }
            .feature-box { background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 5px; padding: 15px; margin: 20px 0; }
            .frameworks-list { margin: 20px 0; }
            .framework { margin-bottom: 15px; border-left: 3px solid #4A90E2; padding-left: 15px; }
            .framework-name { font-weight: bold; color: #4A90E2; }
            .example-box { background-color: #f0f9ff; border: 1px solid #bfdbfe; padding: 15px; border-radius: 5px; margin: 20px 0; }
            h1 { color: #fff; }
            h2 { color: #D9974B; }
            .accent { color: #D9974B; font-weight: bold; }
            .logo-section { text-align: center; margin-bottom: 15px; }
            .logo { width: 100px; height: auto; }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-section">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/aicontentwriter2.png" alt="AISEOBlogGenerator Logo" class="logo" />
            </div>
            <h1>Content Frameworks: Structure = Success</h1>
          </div>
          <div class="content">
            <p>Hey ${name},</p>
            
            <p>There's a reason why almost every book on creating high-converting sales pages, landing copy, or marketing content talks about <span class="accent">frameworks</span>.</p>
            
            <p>Because they <strong>work</strong>.</p>
            
            <p>Frameworks are the hidden architecture that give your content a backbone - they're proven psychological patterns that guide readers toward a specific outcome.</p>
            
            <h2>Choose Your Framework, Choose Your Results</h2>
            
            <p>One of the most powerful but overlooked features of AISEOBlogGenerator is the ability to select specific content frameworks for every post you generate.</p>
            
            <div class="frameworks-list">
              <div class="framework">
                <div class="framework-name">AIDA (Attention, Interest, Desire, Action)</div>
                <p>Perfect for landing page copy, sales emails, and content designed to drive immediate action.</p>
              </div>
              
              <div class="framework">
                <div class="framework-name">PAS (Problem, Agitation, Solution)</div>
                <p>Ideal for addressing pain points and positioning your product/service as the answer.</p>
              </div>
              
              <div class="framework">
                <div class="framework-name">STAR (Situation, Task, Action, Result)</div>
                <p>Excellent for case studies, customer stories, and demonstrating how your solution works in real scenarios.</p>
              </div>
              
              <div class="framework">
                <div class="framework-name">FAB (Features, Advantages, Benefits)</div>
                <p>Great for product-focused content when you need to demonstrate how features translate to customer benefits.</p>
              </div>
            </div>
            
            <div class="example-box">
              <h3 style="margin-top:0;">Example: PAS Framework in Action</h3>
              <p><strong>Problem:</strong> "Most AI content tools produce generic, robotic-sounding content that readers can spot from a mile away."</p>
              <p><strong>Agitation:</strong> "This damages your credibility, wastes your marketing budget, and gives your competitors an edge. Worse, it trains your audience to ignore your content entirely."</p>
              <p><strong>Solution:</strong> "AISEOBlogGenerator uses premium AI models and custom writing styles to produce content that sounds genuinely human, builds trust, and actually converts."</p>
            </div>
            
            <p>Using the right framework for your specific content goal is like using the right tool for the job. You wouldn't use a hammer to tighten a screw, so why use a generic content structure when you need a specific outcome?</p>
            
            <div style="text-align: center;">
              <a href="https://aiseobloggenerator.com/writer" class="button">Try Content Frameworks</a>
            </div>
            
            <p>The most successful content creators aren't just good at writing - they understand structure. With our frameworks feature, you get that advantage with every piece of content you create.</p>
            
            <div style="text-align: center; margin: 30px 0;">
              <img src="https://emp3.b-cdn.net/seoblogtool/png/letaidothewriting.png" alt="Let AI do the writing" style="max-width: 150px; height: auto;" />
            </div>
            
            <p>To structured success,<br>The AISEOBlogGenerator Team</p>
          </div>
          <div class="footer">
            <p>© ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.</p>
            <p><a href="https://aiseobloggenerator.com/privacy" style="color: #4A90E2;">Privacy Policy</a> | <a href="https://aiseobloggenerator.com/terms" style="color: #4A90E2;">Terms of Service</a></p>
            <p>Want to stop receiving these emails? <a href="[unsubscribe_link]" style="color: #4A90E2;">Unsubscribe here</a>.</p>
          </div>
        </body>
        </html>
      `;

      const text = `
        Content Frameworks: Structure = Success - AISEOBlogGenerator
        
        Hey ${name},
        
        There's a reason why almost every book on creating high-converting sales pages, landing copy, or marketing content talks about frameworks.
        
        Because they work.
        
        Frameworks are the hidden architecture that give your content a backbone - they're proven psychological patterns that guide readers toward a specific outcome.
        
        Choose Your Framework, Choose Your Results
        
        One of the most powerful but overlooked features of AISEOBlogGenerator is the ability to select specific content frameworks for every post you generate.
        
        Available frameworks include:
        
        AIDA (Attention, Interest, Desire, Action)
        Perfect for landing page copy, sales emails, and content designed to drive immediate action.
        
        PAS (Problem, Agitation, Solution)
        Ideal for addressing pain points and positioning your product/service as the answer.
        
        STAR (Situation, Task, Action, Result)
        Excellent for case studies, customer stories, and demonstrating how your solution works in real scenarios.
        
        FAB (Features, Advantages, Benefits)
        Great for product-focused content when you need to demonstrate how features translate to customer benefits.
        
        Example: PAS Framework in Action
        
        Problem: "Most AI content tools produce generic, robotic-sounding content that readers can spot from a mile away."
        
        Agitation: "This damages your credibility, wastes your marketing budget, and gives your competitors an edge. Worse, it trains your audience to ignore your content entirely."
        
        Solution: "AISEOBlogGenerator uses premium AI models and custom writing styles to produce content that sounds genuinely human, builds trust, and actually converts."
        
        Using the right framework for your specific content goal is like using the right tool for the job. You wouldn't use a hammer to tighten a screw, so why use a generic content structure when you need a specific outcome?
        
        Try Content Frameworks: https://aiseobloggenerator.com/writer
        
        The most successful content creators aren't just good at writing - they understand structure. With our frameworks feature, you get that advantage with every piece of content you create.
        
        To structured success,
        The AISEOBlogGenerator Team
        
        © ${new Date().getFullYear()} AISEOBlogGenerator. All rights reserved.
        Privacy Policy: https://aiseobloggenerator.com/privacy
        Terms of Service: https://aiseobloggenerator.com/terms
        
        Want to stop receiving these emails? Unsubscribe here: [unsubscribe_link]
      `;

      return {
        html,
        text
      };
    }
  }
];

/**
 * Returns an onboarding drip email template by ID
 * @param id Template ID to retrieve
 * @param name Recipient name
 * @returns Email template with HTML and text versions
 */
export const getOnboardingDripEmail = (id: string, name: string) => {
  const template = onboardingDripTemplates.find(t => t.id === id);
  if (!template) {
    throw new Error(`Drip template with ID "${id}" not found`);
  }
  
  return template.template(name);
};